import * as React from "react";
import { Box, Button, useTheme } from "@material-ui/core";
import * as styles from "./styles.scss";

interface IProps {
  icon?: string;
}

export const CoverPreview = ({ icon }: IProps) => {
  const theme = useTheme();

  return (
    <Box className={styles.wrap}>
      <Button
        component="label"
        variant="contained"
        className={`MuiButton-cover ${styles.button} ${styles.coursesPreview}`}
      >
        {icon ? (
          <Box
            bgcolor={theme.palette.background.paper}
            className={styles.cover}
          >
            <img src={icon} className={styles.image} />
          </Box>
        ) : null}
      </Button>
    </Box>
  );
};
